export default __webpack_public_path__ + "fe20785bc31acf28fef2e23393f70f81.svg";